var AppDispatcher = require('../dispatcher/AppDispatcher');
var StateConstants = require('../constants/StateConstants');

// Define action methods
var StateActions = {
  // Receive inital product data
  receiveState: function (data) {
    AppDispatcher.handleAction({
      actionType: StateConstants.RECEIVE_DATA,
      data: data
    })
  },
  updateState:function(data){
    AppDispatcher.handleAction({
      actionType: StateConstants.UPDATE_SERVICE,
      data: data
    })
  },
  editMessage:function(data){
    AppDispatcher.handleAction({
      actionType: StateConstants.EDIT_MESSAGE,
      data: data
    })
  },
  deleteMessage:function(){
    AppDispatcher.handleAction({
      actionType: StateConstants.DELETE_MESSAGE
    })
  }
};

module.exports = StateActions;


/** WEBPACK FOOTER **
 ** ./src/actions/StateActions.js
 **/